export default __webpack_public_path__ + "images/513b60ac8c1fad4ddcadd605eb55029d-christmas.webp";